<h4>
 Add Rule To Quote
</h4>
<button mat-icon-button class="close-button" [mat-dialog-close]="true" style="margin-top:0px">  <mat-icon class="close-icon" color="warn">close</mat-icon></button>
<div style="width: 900px">
  <div style="margin-left: 25%; position:absolute; vertical-align: middle; align-content:center;" *ngIf="loadingPossibleRecommendations">
    <mat-spinner></mat-spinner>
  </div>
  <table class="mat-table">
    <tr *ngFor="let rule of RuleDetails" class="mat-row">
      <td style="align-content: center;" class="mat-cell checkCol">
        <mat-checkbox [disabled]="rule.RuleAdded" [title]="rule.RuleAdded ? 'Rule already added!!' : 'Click to add rule.'" (change)="addRuleComponent(rule.RuleSelected, rule.RuleId)" [(ngModel)]="rule.RuleSelected">
        </mat-checkbox>
      </td>
      <td class="mat-cell cell-nowrap">{{rule.RuleName}}</td>
      <td class="mat-cell cell-nowrap">{{rule.RuleDetails}}</td>
      <td class="mat-cell cell-nowrap">{{rule.Components}}</td>
    </tr>
  </table>
</div>
<div style="margin-top: 12px;" *ngIf="_DataCount == 0">{{'There are currently no recommendation(s) to add for this quote.' | translate | async}}</div>
<div class="bottomRow"></div>
